import './Tab.css';

export default function Tab({title, description, verticalAlignment}) {
    return(
        <div className={verticalAlignment === true ? "vertical" : "horizontal"}>
            <h2>{title}</h2>
            <p>{description}</p>
        </div>
    );
}